class BundleBuilder extends HTMLElement {

  constructor() {
    super();
    this.promises = [];
    this.parentTitle = this.getAttribute('data-parent-title');
    this.parentID = this.getAttribute('data-parent-id');
    this.bundleMin = parseInt(this.getAttribute('data-bundle-min'));
    this.bundleMax = parseInt(this.getAttribute('data-bundle-max'));
    this.bundleDiscount = parseInt(this.getAttribute('data-bundle-discount'));
    this.bundleDiscountName = this.getAttribute('data-bundle-discount-name');
    this.cart = document.querySelector("cart-drawer");
    this.submitButton = document.querySelector("js-bundle-submit");
    this.init();
  }

  init() {
    const bundleItems = this.querySelectorAll('.js-bundle-item-placeholder'); 

    bundleItems.forEach((el, index) => {
      this.buildProduct(el, index);
    });

    Promise.allSettled(this.promises)
    .then(() => {
      this.classList.remove('bundle-builder--loading');
      this.listeners();
      this.promises = [];
    });
  }

  buildProduct(el, index) {
    const url = el.getAttribute('data-bundle-item-url');
    const handle = el.getAttribute('data-bundle-item-handle');

    const getProduct = () => {
      const promise = new Promise(resolve => {
        async function getProductInfo(url) {
          
          let response = await fetch(url);
          let res = await response.text();
          let parser = new DOMParser();
          let data = parser.parseFromString(res, "text/html");
          return data;
        }

        getProductInfo(url).then((data) => {
          const product = data.querySelector('.js-bundle-item');

          if (product) {
            resolve({ product: product.innerHTML, index: index });
          } else {
            resolve(null);
          }
        })
      });
  
      this.promises.push(promise);
  
      return promise;
    }

    getProduct()
    .then((data) => {
      const productPlaceholders = document.querySelectorAll(`.js-bundle-item-placeholder-${handle}`);
    
      productPlaceholders.forEach((el) => {
        if (data && data.product) {
          const category = el.getAttribute('data-bundle-category');
          const step = el.getAttribute('data-step');
  
          el.innerHTML = data.product;
  
          const card = el.querySelector('.js-bundle-card');
          const modalShow = el.querySelector('.js-bundle-modal-show');
          const sideDrawer = el.querySelector('.side-drawer');

          if (card) {
            card.setAttribute('data-bundle-category', category);
            card.setAttribute('data-step', step);
            card.setAttribute('data-bundle-index', index);
          }

          if (modalShow) {
            modalShow.setAttribute('data-modal-category', category);
            modalShow.setAttribute('data-modal-index', index);
          }

          if (sideDrawer) {
            sideDrawer.setAttribute('data-step', step);
          }
        } else {
          el.style.display = 'none';
        }
      });
    });
  }

  listeners() {
    const form = this.querySelector('.js-bundle-builder-form');
    const clearButton = this.querySelectorAll('.js-bundle-clear');

    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();

        const submitButton = this.querySelector('.js-bundle-submit');
        const bundleItems = this.querySelectorAll('.js-bundle-card-checked');

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        submitButton.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );
        
        if (bundleItems.length < this.bundleMin || bundleItems.length > this.bundleMax) {
          let min = ''
          
          if (this.bundleMin !== this.bundleMax) {
            min = `${this.bundleMin}-`;
          }

          const minMaxError = bundleBuilderStrings.minMaxError.replace('[min]', min).replace('[max]', this.bundleMax);

          throw new Error(minMaxError);
        }

        if (submitButton.getAttribute('disabled')) {
          return;
        }
  
        form.classList.add('is-loading');

        const timeStamp = Date.now();
        const properties = {
          '_Bundle ID': `${this.parentID}:${timeStamp}`,
          '_Bundle Size': bundleItems.length,
          '_Bundle Discount Name': this.bundleDiscountName,
          '_Parent ID': this.parentID,
          '_Parent Title': this.parentTitle
        };

        const formData = {
          items: []
        };

        if (this.cart) {
          formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          formData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        bundleItems.forEach((el) => {
          let id = el.getAttribute('data-product-id');
          let variantId = el.getAttribute('data-variant-id');
          if (variantId) {
            id = variantId;
          }

          formData.items.push({
            id: id,
            quantity: 1,
            properties: properties
          })
        });

        

        fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.ok) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form"
            });
          }
          this.error = false;
          this.cart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.disabled = false
          submitButton.classList.remove("loading");
          if (this.cart && this.cart.classList.contains("is-empty"))
            this.cart.classList.remove("is-empty");
          if (!this.error) submitButton.removeAttribute("aria-disabled");
          submitButton.querySelector(".loading-overlay__spinner").classList.add(
            "hidden"
          );
          this.clear();
        })
      });
      
      document.addEventListener('bundle:updatePrice', () => {
        this.updatePrice();
      });

      document.addEventListener('bundle:updateItemCount', () => {
        this.updateItemCount();
      });
    }

    if (clearButton) {
      clearButton.forEach((el) => {
        el.addEventListener('click', () => {
          this.clear();
        });
      });
    }
  }

  clear() {
    const bundleCards = this.querySelectorAll('.js-bundle-card');

    bundleCards.forEach((el) => {
      el.classList.remove('bundle-item--checked');
      el.classList.remove('js-bundle-card-checked');
      el.classList.remove('bundle-item--disabled');
      el.removeAttribute('data-variant-id');
    });

    this.updatePrice();
    this.updateItemCount();
  }

  updatePrice() {
    const bundleItems = this.querySelectorAll('.js-bundle-card-checked .js-bundle-card-actions');
    const bundlePrice = this.querySelectorAll('.js-bundle-price');
    const discount = (100 - this.bundleDiscount) / 100;

    let totalPrice = 0;
    let totalCompareAtPrice = 0;

    bundleItems.forEach((el) => {
      const price = parseInt(el.getAttribute('data-variant-price'));
      const compareAtPrice = parseInt(el.getAttribute('data-variant-compare-at-price'));

      if (isNaN(price)) return;

      if (!isNaN(compareAtPrice)) {        
        totalPrice += Math.round(price * discount);
        totalCompareAtPrice += compareAtPrice;
      } else {
        totalPrice += Math.round(price * discount);
        totalCompareAtPrice += price;
      }
    });

    this.setAttribute('data-discounted-price', totalPrice);
    this.setAttribute('data-original-price', totalCompareAtPrice);
    this.setAttribute('data-total-discount', totalCompareAtPrice - totalPrice);

    bundlePrice.forEach((el) => {
      if (totalPrice === 0 || totalCompareAtPrice === 0) {
        el.innerHTML = Shopify.formatMoney(totalPrice, window.money.format)
      } else {
        el.innerHTML = `
          <span class="bundle-builder__price-sale">${Shopify.formatMoney(totalPrice, window.money.format)}</span>
          <s class="bundle-builder__price-compare-at-price">${Shopify.formatMoney(totalCompareAtPrice, window.money.format)}</s>
        `
      }
    })
  }

  updateItemCount() {
    const categories = this.querySelectorAll('.js-bundle-builder-category');
    const bundleItems = this.querySelectorAll('.js-bundle-card-checked .js-bundle-card-actions');
    const bundleItemCount = bundleItems.length;
    const submitButton = this.querySelectorAll('.js-bundle-submit');
    const clearButton = this.querySelectorAll('.js-bundle-clear');
    const totalItemsSidebar = this.querySelector('.js-bundle-total-items-sidebar');
    const progressBarSidebar = this.querySelector('.js-bundle-progress-bar-sidebar');
    const sidebarProgress = 1 - (bundleItemCount / this.bundleMax);
    const totalItems = this.querySelector('.js-bundle-total-items');
    const progressBar = this.querySelector('.js-bundle-progress-bar');
    const progress = (bundleItemCount / this.bundleMax) * 100;
    let itemLimit = this.bundleMax;

    categories.forEach((el) => {
      const bundleItems = el.querySelectorAll('.js-bundle-card-checked .js-bundle-card-actions');

      if (bundleItems.length) {
        el.classList.add('bundle-builder__collection--has-selected');
      } else {
        el.classList.remove('bundle-builder__collection--has-selected');
      }
    });

    totalItemsSidebar.innerText = bundleItemCount;
    progressBarSidebar.style.strokeDashoffset = 198 * sidebarProgress;

    if (this.bundleMin !== this.bundleMax) {
      itemLimit = `${this.bundleMin}-${this.bundleMax}`;
    }

    totalItems.innerText = bundleBuilderStrings.totalSelected.replace('[selected]', bundleItemCount).replace('[limit]', itemLimit);
    progressBar.style.width = `${progress}%`;

    if (bundleItemCount >= this.bundleMin) {
      submitButton.forEach((el) => {
        el.removeAttribute('disabled');
      })
    } else {
      submitButton.forEach((el) => {
        el.setAttribute('disabled', 'disabled');
      })
    }

    if (bundleItemCount >= this.bundleMax) {
      categories.forEach((el) => {
        if (!el.classList.contains('bundle-builder__collection--has-selected')) {
          el.classList.add('bundle-builder__collection--max-reached');
        }
      })
    } else {
      categories.forEach((el) => {
        el.classList.remove('bundle-builder__collection--max-reached');
      })
    }

    if (bundleItemCount === 0) {
      clearButton.forEach((el) => {
        el.setAttribute('disabled', 'disabled');
      })
    } else {
      clearButton.forEach((el) => {
        el.removeAttribute('disabled');
      })
    }
  }
}

customElements.define('bundle-builder', BundleBuilder);

class BundleProductCard extends HTMLElement {

  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    const self = this;
    const toggleAddToBundle = this.querySelectorAll('.js-toggle-add-to-bundle');
    const category = this.closest('.js-bundle-builder-category');
    
    toggleAddToBundle.forEach((el) => {
      el.addEventListener('click', () => {

        const otherCards = [...category.querySelectorAll('.js-bundle-card')].filter((el) => el !== this);
  
        // A product card gets a variant id data attribute, if the user adds a variant
        if(el.classList.contains('bundle-product-card__variant-remove')
        || el.classList.contains('bundle-product-card__bundle-remove')) {

          this.removeAttribute('data-variant-id');
          const variantLabel = this.querySelector('.bundle-product-card__variant-label');
          if (variantLabel) {
            variantLabel.innerText = "";
          }
        } else if (el.hasAttribute('data-variant-id')) {
          this.setAttribute('data-variant-id', el.getAttribute('data-variant-id'));
          this.querySelector('.js-bundle-card-actions').setAttribute('data-product-id', el.getAttribute('data-variant-id'));
          this.querySelector('.js-bundle-card-actions').setAttribute('data-variant-price', el.getAttribute('data-variant-price'));
          this.querySelector('.js-bundle-card-actions').setAttribute('data-variant-compare-at-price', el.getAttribute('data-variant-compare-at-price'));
          this.querySelector('.bundle-product-card__variant-label').innerText = el.getAttribute('data-variant-title');
        }

        this.classList.toggle('bundle-item--checked');
        this.classList.toggle('js-bundle-card-checked');
  
        otherCards.forEach((el) => {
          el.classList.toggle('bundle-item--disabled', this.classList.contains('js-bundle-card-checked'));
          el.classList.remove('js-bundle-card-checked');
        });
  
        document.dispatchEvent(
          new CustomEvent('bundle:updatePrice')
        )
  
        document.dispatchEvent(
          new CustomEvent('bundle:updateItemCount')
        )

        // bundle-product-card__variant-remove
        // Does this button have a side-drawer ancestor
        const sideDrawer = el.closest('.side-drawer');
        if (sideDrawer) {
          // toggle data-bundle-variant-chosen
          sideDrawer.setAttribute('data-bundle-variant-chosen', this.classList.contains('js-bundle-card-checked'));

          sideDrawer.close();
        }
      })
    });
  }
}

customElements.define('bundle-product-card', BundleProductCard);
